import { Link } from '@heroui/react';
import { useTranslation } from 'react-i18next';

const COPYRIGHT_TEXT = `© ${new Date().getFullYear()} 數願履歷 Digital Vision Resume. All rights reserved.`;

export function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="border-default-200 w-full border-t py-6">
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center gap-2">
          <div className="text-small text-default-500 flex gap-4">
            <Link color="foreground" href="/">
              {t('about')}
            </Link>
            <Link color="foreground" href="/">
              {t('privacy')}
            </Link>
            <Link color="foreground" href="/">
              {t('terms')}
            </Link>
            <Link color="foreground" href="/">
              {t('contact')}
            </Link>
          </div>
          <p className="text-small text-default-400">{COPYRIGHT_TEXT}</p>
        </div>
      </div>
    </footer>
  );
}
